export default "__VITE_ASSET__DlXIBU2q__"